import { Construction } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function ComingSoon({ title = "Coming soon" }: { title?: string }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <Card className="max-w-md text-center">
        <CardContent className="flex flex-col items-center gap-3 p-8">
          <Construction size={48} className="text-muted" />
          <h2 className="text-lg font-semibold text-ink dark:text-cream-50">{title}</h2>
          <p className="text-sm text-muted">This module will be available in an upcoming release.</p>
        </CardContent>
      </Card>
    </div>
  );
}
